import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';

import { CursorOverlayRef } from './cursor-overlay-ref';
import { CursorComponent } from './cursor.component';

@Injectable({
  providedIn: 'root',
})
export class CursorService {
  private cursorOverlayRef!: CursorOverlayRef | null;

  constructor(private overlay: Overlay) {}

  create(): CursorOverlayRef {
    if (!this.cursorOverlayRef) {
      const overlayRef = this.overlay.create({});
      const componentPortal = new ComponentPortal(CursorComponent);
      componentPortal;

      this.cursorOverlayRef = new CursorOverlayRef(overlayRef);

      const portal = overlayRef.attach(componentPortal);
      this.cursorOverlayRef.componentInstance = portal.instance;
    }

    return this.cursorOverlayRef;
  }

  close() {
    if (this.cursorOverlayRef) {
      this.cursorOverlayRef.close();
      this.cursorOverlayRef = null;
    }
  }
}
